import PathUrlGenerator, {COMPRESSTION_OPTION} from "./PathUrlGenerator";

export default class ImgixPathUrlGenerator extends PathUrlGenerator {

    constructor(url){
        super(url);
        this.compress = COMPRESSTION_OPTION.auto
    }

    build() {
        var url = new URL(this.url);
        url.searchParams.append('auto','compress,format')
        url.searchParams.append('q',this.quality);         
        
        if(this.height) {
            url.searchParams.append('h', this.height);
        }
       
        if(this.width) {
            url.searchParams.append('w',this.width);
        }
        
        if(this.otherOptions) {
            const otherOption = this.otherOptions;
            Object.keys(this.otherOptions).forEach((key) => {
                url.searchParams.append(key, otherOption[key]);
            });
        }

        url = url.toString().replace(/%2C/g,",");
        
        return url;
    }
      
}